export class BillingConfigContract {
    public idBillingConfigContract: number;
    public billingContractName: string;      
    public billingContractReportName: string;      
    public idBillingConfig: number;      
    public datetimeInclusion: Date;      
    public capacity: string;      
    public reportMimeType: string;      
}